export default function extractBrandNameFromProductId(productId: string): string {
  const split = productId.split('_');
  return split[1];
}
